import {
  GET_CANCEL_REASON_FAILED,
  GET_CANCEL_REASON_REQUESTED,
  GET_CANCEL_REASON_SUCCESS,
  GET_CANCEL_TRIP_FAILED,
  GET_CANCEL_TRIP_REQUESTED,
  GET_CANCEL_TRIP_SUCCESS,
  GET_CLEAR_RATE_CALCULATION,
  GET_RATE_CALCULATION_FAILED,
  GET_RATE_CALCULATION_REQUESTED,
  GET_RATE_CALCULATION_SUCCESS,
  GET_REFUND_PRICE_FAILED,
  GET_REFUND_PRICE_REQUESTED,
  GET_REFUND_PRICE_SUCCESS,
  GET_RENATAL_SLAB_FAILED,
  GET_RENATAL_SLAB_REQUESTED,
  GET_RENATAL_SLAB_SUCCESS,
  GET_TRIP_CHECKOUT_FAILED,
  GET_TRIP_CHECKOUT_REQUESTED,
	GET_TRIP_CHECKOUT_SUCCESS,
  GET_TRIP_SLAB_FAILED,
  GET_TRIP_SLAB_REQUESTED,
  GET_TRIP_SLAB_SUCCESS,
} from "resources/actionTypes";

const intialState = {
  userRateCalculation: [],
  loading: false,
  error: null,
};
const tripInitialState = {
  userTripCheckout: [],
  loading: false,
  error: null,
};
const tripSlabInitialState = {
  userTripSlab:[],
  loading:false,
  error:null,
}
const cancelIntialState = {
  userCancelTrip:[],
  loading:false,
  error:null,
}
const cancelReasonInitialState = {
  userCancelReason:[],
  loading:false,
  error:null,
}
const refundPriceIntialState = {
  userRefundPrice:[],
  loading:false,
  error:null
}

const intialStateRentalSlab = {
  userRentalSlab: [],
  loading: false,
  error: null,
};

export function userRateCalculation(state = intialState, action) {
  switch (action.type) {
    case GET_RATE_CALCULATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RATE_CALCULATION_SUCCESS:
      return {
        ...state,
        loading: false,
        userRateCalculation: action.userRateCalculation,
      };
    case GET_RATE_CALCULATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_CLEAR_RATE_CALCULATION:
      return {
        ...state,
        loading: false,
        userRateCalculation:'',

      }
    default:
      return state;
  }
}

export function userTripCheckout(state = tripInitialState, action) {
  switch (action.type) {
    case GET_TRIP_CHECKOUT_REQUESTED:
			return {
				...state,
				loading: true,
			};
		case GET_TRIP_CHECKOUT_SUCCESS:
			return {
				...state,
				loading: false,
				userTripCheckout:action.userTripCheckout,
			};
		case GET_TRIP_CHECKOUT_FAILED:
			return {
				...state,
				loading: false,
				error: action.message,
			}
		default:
			return state;
  }
}

export function userTripSlab(state = tripSlabInitialState, action){
  switch (action.type){
    case GET_TRIP_SLAB_REQUESTED:
      return {
        ...state,
        loading:true,
  
      };
    case GET_TRIP_SLAB_SUCCESS:
      return {
        ...state,
        loading:false,
        userTripSlab:action.userTripSlab,
      };
    case GET_TRIP_SLAB_FAILED:
      return {
        ...state,
        loading:false,
        error:action.message,
      }
      default:
        return state;
  }
}
export function userCancelTrip(state = cancelIntialState, action){
  switch (action.type){
    case GET_CANCEL_TRIP_REQUESTED:
      return {
        ...state,
        loading:true,
  
      };
    case GET_CANCEL_TRIP_SUCCESS:
      return {
        ...state,
        loading:false,
        userCancelTrip:action.userCancelTrip,
      };
    case GET_CANCEL_TRIP_FAILED:
      return {
        ...state,
        loading:false,
        error:action.message,
      }
      default:
        return state;
  }
}
export function userCancelReason(state = cancelReasonInitialState, action){
  switch (action.type){
    case GET_CANCEL_REASON_REQUESTED:
      return {
        ...state,
        loading:true,
  
      };
    case GET_CANCEL_REASON_SUCCESS:
      return {
        ...state,
        loading:false,
        userCancelReason:action.userCancelReason,
      };
    case GET_CANCEL_REASON_FAILED:
      return {
        ...state,
        loading:false,
        error:action.message,
      }
      default:
        return state;
  }
}
export function userRefundPrice(state = refundPriceIntialState, action){
  switch (action.type){
    case GET_REFUND_PRICE_REQUESTED:
      return {
        ...state,
        loading:true,
  
      };
    case GET_REFUND_PRICE_SUCCESS:
      return {
        ...state,
        loading:false,
        userRefundPrice:action.userRefundPrice,
      };
    case GET_REFUND_PRICE_FAILED:
      return {
        ...state,
        loading:false,
        error:action.message,
      }
    default:
      return state;
  }
}
export function userRentalSlab(state = intialStateRentalSlab, action) {
  switch (action.type) {
    case GET_RENATAL_SLAB_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RENATAL_SLAB_SUCCESS:
      return {
        ...state,
        loading: false,
        userRentalSlab: action.userRentalSlab,
      };
    case GET_RENATAL_SLAB_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
